import Nav from "components/nav";
// import Image from "next/image";
import ToggleSwitch from "components/toggleSwitch";
import React from "react";
import Hamburger from "components/hamburger";

const links = [
  {
    name: "Home",
    location: "/",
  },
  {
    name: "About",
    location: "/about",
  },
  {
    name: "Services",
    location: "/services",
  },
  {
    name: "Projects",
    location: "/projects",
  },
];

/* TODO: Improve mobile header */
export default function Header() {
  const [menuOpen, setMenuOpen] = React.useState(false);
  return (
    <>
      <header
        id="header"
        role="banner"
        className={`z-10 max-w-screen ${
          menuOpen ? "max-h-screen overflow-hidden" : ""
        } `}
      >
        <ToggleSwitch />
        <div
          className={`fixed max-w-screen overflow-hidden inset-0 h-full w-screen bg-indigo-200 dark:bg-indigo-800 transition-all ease-in-out duration-500 transform  ${
            menuOpen ? "translate-x-0 max-h-screen" : "-translate-x-full"
          }`}
        ></div>
        <div
          className={`flex w-full ${
            menuOpen ? "h-screen" : ""
          } p-4 transition duration-500 ease-in-out md:bg-transparent `}
        >
          <div className="flex flex-col w-full md:px-24 md:flex-row md:items-center md:justify-between">
            <div
              className={`${
                menuOpen ? "fixed" : ""
              } relative flex justify-start w-full md:hidden`}
            >
              <button
                className="block bg-transparent border-transparent cursor-pointer md:hidden focus:outline-none"
                type="button"
                aria-label="Open Menu"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <Hamburger open={menuOpen} />
              </button>
            </div>
            <div
              role="navigation"
              className={`md:flex w-full ${
                menuOpen ? "flex h-full -mt-12" : "hidden"
              }`}
            >
              <ul className="flex flex-col content-center justify-center w-full list-none md:justify-between md:flex-row">
                {links.map(({ name, location }, index) => (
                  <li
                    key={name}
                    className="nav-item"
                    style={{ order: index <= 1 ? index : index + 1 }}
                  >
                    <div className="m-3 text-center">
                      <Nav
                        href={location}
                        activeClassName="active font-extrabold"
                      >
                        <a
                          className="text-3xl md:text-xl"
                          onMouseUp={() =>
                            setTimeout(() => setMenuOpen(false), 250)
                          }
                        >
                          {name}
                        </a>
                      </Nav>
                    </div>
                  </li>
                ))}
                <li className="order-2 hidden nav-item md:block">
                  <Nav href="/">
                    <a rel="home" title="to homepage" className="no-underline">
                      <div className="hidden dark:block">
                        <svg
                          className="w-12 h-12"
                          viewBox="0 0 512 512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            clipRule="evenodd"
                            d="M7.56 121.97l243.04 33.55 253.84-33.55V76.76c0-27.9-22.87-50.71-50.78-50.71H58.3c-27.91 0-50.75 22.82-50.75 50.7z"
                            fill="#eee1dc"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M504.44 435.21V121.97H7.56v313.25c0 27.91 22.84 50.73 50.75 50.73h395.35c27.91 0 50.78-22.82 50.78-50.73z"
                            fill="#60b7ff"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M448.7 377c4.28 0 7.8-3.5 7.8-7.78v-20.67a7.82 7.82 0 00-7.8-7.78h-7.48a64.65 64.65 0 00-5.47-13.34l5.24-5.24a7.77 7.77 0 000-10.98l-14.62-14.64a7.82 7.82 0 00-11.03 0l-5.24 5.24a64.14 64.14 0 00-13.35-5.47v-7.47a7.78 7.78 0 00-7.8-7.76h-20.68a7.8 7.8 0 00-7.8 7.76v7.81a63.92 63.92 0 00-12.95 5.53l-5.64-5.64a7.79 7.79 0 00-11 0l-14.64 14.64a7.77 7.77 0 000 10.98l5.98 5.98a62.72 62.72 0 00-5.1 12.6h-8.6a7.8 7.8 0 00-7.76 7.78v20.67a7.8 7.8 0 007.77 7.79h8.93a65.6 65.6 0 005.13 12.23l-6.35 6.34a7.8 7.8 0 000 11.01l14.65 14.61a7.79 7.79 0 0011 0l6.34-6.34a62.16 62.16 0 0012.25 5.12v8.92a7.82 7.82 0 007.79 7.79h20.69a7.8 7.8 0 007.8-7.79v-8.58a65.51 65.51 0 0012.63-5.07l5.95 5.95a7.82 7.82 0 0011.03 0l14.62-14.6a7.8 7.8 0 000-11.02l-5.64-5.63a62.38 62.38 0 005.53-12.94zm-70.09-50.05a31.95 31.95 0 110 63.87c-17.65 0-31.97-14.3-31.97-31.93s14.32-31.94 31.97-31.94z"
                            fill="#9d9696"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M378.61 390.82c17.66 0 31.97-14.3 31.97-31.93s-14.31-31.94-31.97-31.94-31.97 14.3-31.97 31.94 14.32 31.93 31.97 31.93z"
                            fill="#eee1dc"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M296.26 89.36a16.02 16.02 0 100-32.05 16.02 16.02 0 100 32.05z"
                            fill="#fd4755"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M364.44 89.36a16.02 16.02 0 100-32.05 16.02 16.02 0 100 32.05z"
                            fill="#fdb440"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M432.63 89.36a16.04 16.04 0 100-32.05c-8.87 0-16.07 7.16-16.07 16.02s7.2 16.03 16.07 16.03z"
                            fill="#80d261"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M504.44 121.97V76.76c0-27.9-22.87-50.71-50.78-50.71H425.7c27.92 0 50.76 22.82 50.76 50.7v45.22h27.97z"
                            fill="#cdbeb9"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M504.44 435.21V121.97h-27.97v313.25c0 27.91-22.84 50.73-50.76 50.73h27.95c27.91 0 50.78-22.82 50.78-50.73z"
                            fill="#22a6fe"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M359.8 296.88c7.28 8.04 13.37 18.3 17.85 30.1.31-.03.65-.03.96-.03a31.95 31.95 0 016.5 63.22c-1.93 17.55-7.06 33.52-14.49 46.52h18.34a7.8 7.8 0 007.8-7.79v-8.58a65.51 65.51 0 0012.63-5.06l5.95 5.94a7.82 7.82 0 0011.03 0l14.62-14.6a7.8 7.8 0 000-11.02l-5.64-5.63a62.38 62.38 0 005.53-12.94h7.82c4.28 0 7.8-3.51 7.8-7.79v-20.67a7.82 7.82 0 00-7.8-7.78h-7.48a64.65 64.65 0 00-5.47-13.34l5.24-5.24a7.77 7.77 0 000-10.98l-14.62-14.64a7.82 7.82 0 00-11.03 0l-5.24 5.24a64.14 64.14 0 00-13.35-5.46v-7.48a7.78 7.78 0 00-7.8-7.75h-20.68a7.8 7.8 0 00-7.8 7.75v7.82c-.22.05-.45.14-.67.2z"
                            fill="#746e6e"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M377.65 326.98c5.3 13.98 8.33 30.12 8.33 47.36 0 5.38-.31 10.68-.88 15.83a31.95 31.95 0 00-6.49-63.22z"
                            fill="#cdbeb9"
                            fillRule="evenodd"
                          />
                          <path d="M210.67 191.01h232.02a7.55 7.55 0 100-15.1H210.67a7.55 7.55 0 100 15.1zM210.67 246.03h232.02a7.55 7.55 0 100-15.1H210.67a7.55 7.55 0 100 15.1zM272.65 285.96h-89.61a7.55 7.55 0 100 15.1h89.61a7.55 7.55 0 100-15.1zM78 293.51a7.55 7.55 0 007.55 7.55h57.53a7.55 7.55 0 100-15.1H85.55a7.55 7.55 0 00-7.56 7.55zM99.86 263.92a7.55 7.55 0 100-15.1c-4.22 0-9.25-2.13-9.25-12.24v-10.65c0-6.22-1.82-10.44-4.22-13.35 2.4-2.91 4.22-7.13 4.22-13.35V188.6c0-10.12 5.03-12.24 9.25-12.24a7.55 7.55 0 100-15.1c-12.13 0-24.36 8.45-24.36 27.34v10.64c0 3.97-.72 4.23-4.2 5.53-.79.3-1.6.6-2.44.98a7.55 7.55 0 00-.56 13.4c.16.11 2.25 1 3 1.28 3.48 1.28 4.2 1.54 4.2 5.51v10.64c0 18.9 12.23 27.35 24.36 27.35zM148.42 235.39c0 10.12-5.03 12.24-9.25 12.24a7.55 7.55 0 100 15.1c12.13 0 24.36-8.45 24.36-27.34v-10.62c0-3.96.72-4.23 4.2-5.52.75-.28 1.53-.58 2.33-.94l.43-.22a7.55 7.55 0 00-.36-13.55 34.2 34.2 0 00-2.4-.96c-3.48-1.27-4.2-1.54-4.2-5.5v-10.65c0-18.89-12.23-27.34-24.36-27.34a7.55 7.55 0 100 15.1c4.22 0 9.25 2.12 9.25 12.24v10.65c0 6.22 1.82 10.43 4.22 13.35-2.4 2.91-4.22 7.13-4.22 13.35v10.6zM267.66 340.97H84.56a7.55 7.55 0 100 15.1h183.1a7.55 7.55 0 100-15.1zM266.67 396.01H83.57a7.55 7.55 0 100 15.1h183.1a7.55 7.55 0 100-15.1zM432.63 96.9c13.01 0 23.6-10.57 23.6-23.57a23.61 23.61 0 00-47.23 0c0 13 10.6 23.57 23.63 23.57zm0-32.04c4.68 0 8.48 3.8 8.48 8.47a8.5 8.5 0 01-17 0 8.5 8.5 0 018.52-8.47zM364.44 96.9c13.02 0 23.6-10.57 23.6-23.57s-10.58-23.57-23.6-23.57c-13 0-23.6 10.57-23.6 23.57s10.6 23.57 23.6 23.57zm0-32.04c4.68 0 8.49 3.8 8.49 8.47a8.5 8.5 0 01-16.97 0c0-4.67 3.8-8.47 8.48-8.47zM296.26 96.9c13.01 0 23.6-10.57 23.6-23.57s-10.59-23.57-23.6-23.57c-13.02 0-23.6 10.57-23.6 23.57s10.58 23.57 23.6 23.57zm0-32.04c4.68 0 8.48 3.8 8.48 8.47a8.5 8.5 0 01-16.97 0c0-4.67 3.81-8.47 8.49-8.47z" />
                          <path d="M453.66 18.5H58.3C26.16 18.5 0 44.63 0 76.76v358.46a58.37 58.37 0 0058.31 58.28h395.35c32.17 0 58.34-26.15 58.34-58.28V76.76c0-32.13-26.17-58.26-58.34-58.26zm0 459.9H58.3a43.24 43.24 0 01-43.2-43.18v-305.7h111.05a7.55 7.55 0 100-15.1H15.12V76.76a43.23 43.23 0 0143.2-43.16h395.34a43.24 43.24 0 0143.23 43.16v37.66H160.76a7.55 7.55 0 100 15.1H496.9v305.7a43.26 43.26 0 01-43.23 43.18z" />
                          <path d="M448.7 333.22h-2.02a72.32 72.32 0 00-1.75-4.28l1.4-1.4c2.9-2.9 4.5-6.77 4.5-10.89a15.13 15.13 0 00-4.49-10.77l-14.63-14.65a15.26 15.26 0 00-10.86-4.48c-4.1 0-7.96 1.6-10.85 4.48l-1.4 1.4a71.6 71.6 0 00-4.3-1.75v-2.01c0-8.44-6.88-15.3-15.34-15.3h-20.69a15.35 15.35 0 00-15.35 15.3v2.44a70.79 70.79 0 00-3.94 1.68l-1.75-1.76a15.25 15.25 0 00-10.85-4.48h-.04c-4.1 0-7.93 1.6-10.8 4.49l-14.62 14.6c-2.9 2.87-4.5 6.71-4.51 10.81a15.22 15.22 0 004.48 10.88l2.18 2.18c-.5 1.16-.98 2.33-1.42 3.5h-3.12a15.35 15.35 0 00-15.32 15.34v20.67c0 8.45 6.87 15.33 15.32 15.33h3.56a73.2 73.2 0 001.32 3.17l-2.52 2.52a15.35 15.35 0 00.01 21.7l14.62 14.57c2.87 2.9 6.72 4.5 10.82 4.51h.04c4.1 0 7.95-1.59 10.85-4.48l2.5-2.5c1.06.46 2.12.9 3.2 1.32v3.54c0 8.45 6.88 15.33 15.34 15.33h20.69c8.46 0 15.35-6.88 15.35-15.33v-3.12a73 73 0 003.52-1.41l2.17 2.17c2.9 2.89 6.75 4.48 10.86 4.48s7.96-1.6 10.85-4.48l14.63-14.61c2.89-2.9 4.48-6.75 4.48-10.85s-1.59-7.95-4.48-10.84l-1.75-1.75c.6-1.3 1.16-2.61 1.67-3.94h2.44c8.46 0 15.35-6.88 15.35-15.33v-20.67c0-8.45-6.89-15.33-15.35-15.33zm.23 36c0 .1-.13.24-.23.24h-7.82a7.56 7.56 0 00-7.25 5.39 55.09 55.09 0 01-4.86 11.37 7.54 7.54 0 001.24 9.06l5.64 5.64c.08.08.08.25 0 .33l-14.63 14.61c-.03.03-.3.04-.34 0l-5.95-5.94a7.56 7.56 0 00-8.85-1.35 58.12 58.12 0 01-11.18 4.49 7.55 7.55 0 00-5.5 7.26v8.58c0 .1-.11.24-.24.24h-20.7c-.1 0-.23-.13-.23-.24v-8.92c0-3.34-2.2-6.28-5.4-7.23a54.64 54.64 0 01-10.75-4.5 7.54 7.54 0 00-9 1.27l-6.34 6.34c-.02.02-.06.06-.16.06-.09 0-.11-.02-.15-.06l-14.65-14.6c-.08-.09-.08-.26 0-.34l6.35-6.34c2.37-2.37 2.9-6.01 1.3-8.95a58 58 0 01-4.54-10.82 7.56 7.56 0 00-7.23-5.35h-8.93c-.1 0-.21-.12-.21-.24v-20.67c0-.12.12-.23.2-.23h8.6a7.56 7.56 0 007.27-5.5 55.4 55.4 0 014.49-11.09 7.54 7.54 0 00-1.32-8.9l-5.98-5.97c-.02-.02-.06-.06-.06-.17 0-.08.03-.1.06-.14l14.65-14.64.03-.02c0-.01.03-.04.11-.04.1 0 .15.04.17.06l5.64 5.63c2.4 2.4 6.1 2.9 9.05 1.25 3.66-2.06 7.5-3.7 11.42-4.87a7.55 7.55 0 005.38-7.24v-7.8c0-.1.12-.22.24-.22h20.69c.13 0 .23.11.23.21v7.48a7.55 7.55 0 005.5 7.26 56.91 56.91 0 0111.78 4.82 7.56 7.56 0 008.97-1.28l5.25-5.24c.03-.03.3-.03.33 0l14.65 14.66c0 .01.04.04.04.12 0 .1-.05.15-.07.17l-5.24 5.24a7.54 7.54 0 00-1.28 8.96 57.2 57.2 0 014.83 11.78 7.56 7.56 0 007.26 5.48h7.49c.1 0 .23.13.23.23v20.67z" />
                          <path d="M378.61 319.4c-21.8 0-39.52 17.71-39.52 39.49s17.73 39.48 39.52 39.48c21.8 0 39.53-17.71 39.53-39.48S400.4 319.4 378.6 319.4zm0 63.87c-13.46 0-24.4-10.94-24.4-24.38s10.94-24.39 24.4-24.39c13.46 0 24.41 10.94 24.41 24.39s-10.95 24.38-24.4 24.38z" />
                        </svg>
                      </div>
                      <div className="block dark:hidden">
                        <svg
                          className="w-12 h-12"
                          viewBox="0 0 512 512"
                          height="50"
                          width="50"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            clipRule="evenodd"
                            d="M0 118l250 34 262-34V71c0-29-24-52-52-52H52C24 19 0 42 0 71z"
                            fill="#eee1dc"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M512 441V118H0v323c0 29 24 52 52 52h408c28 0 52-23 52-52z"
                            fill="#60b7ff"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M455 381c4 0 8-4 8-8v-22c0-4-4-8-8-8h-8c-2-4-3-9-6-13l6-6c3-3 3-8 0-11l-15-15c-4-3-9-3-12 0l-5 5-14-5v-8c0-5-4-8-8-8h-21c-5 0-8 3-8 8v8c-5 1-9 3-14 6l-6-6c-3-3-8-3-11 0l-15 15c-3 3-3 8 0 11l6 6-5 13h-9c-4 0-8 4-8 8v22c0 4 4 8 8 8h9l6 12-7 7c-3 3-3 8 0 11l15 15c3 4 8 4 11 0l7-6 13 5v9c0 5 3 8 8 8h21c4 0 8-3 8-8v-9l13-5 6 6c3 4 8 4 12 0l15-15c3-3 3-8 0-11l-6-6 6-13h8zm-73-52a33 33 0 110 66 33 33 0 010-66z"
                            fill="#9d9696"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M382 395a33 33 0 100-66 33 33 0 000 66z"
                            fill="#eee1dc"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M297 84a17 17 0 101-33 17 17 0 00-1 33z"
                            fill="#fd4755"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M368 84a17 17 0 100-33 17 17 0 000 33z"
                            fill="#fdb440"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M438 84a17 17 0 100-33 17 17 0 000 33z"
                            fill="#80d261"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M512 118V71c0-29-24-52-52-52h-29c29 0 52 23 52 52v47z"
                            fill="#cdbeb9"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M512 441V118h-29v323c0 29-23 52-52 52h29c28 0 52-23 52-52z"
                            fill="#22a6fe"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M363 298c7 8 14 19 18 31h1a33 33 0 017 65c-2 18-7 35-15 48h19c4 0 8-3 8-8v-9l13-5 6 6c3 4 8 4 12 0l15-15c3-3 3-8 0-11l-6-6 5-13h9c4 0 8-4 8-8v-22c0-4-4-8-8-8h-8c-2-4-3-9-6-13l6-6c3-3 3-8 0-11l-15-15c-4-3-9-3-12 0l-5 5-14-5v-8c0-5-4-8-8-8h-21c-5 0-8 3-8 8v8h-1z"
                            fill="#746e6e"
                            fillRule="evenodd"
                          />
                          <path
                            clipRule="evenodd"
                            d="M381 329a139 139 0 018 65 33 33 0 00-7-65z"
                            fill="#cdbeb9"
                            fillRule="evenodd"
                          />
                          <path
                            d="M448 189H209a8 8 0 110-16h239a8 8 0 110 16zM448 246H209a8 8 0 110-16h239a8 8 0 110 16zM273 302h-92a8 8 0 110-15h92a8 8 0 110 15zM140 302H80a8 8 0 110-15h60a8 8 0 110 15zM95 249c-4 0-9-3-9-13v-11c0-6-2-11-5-14 3-3 5-7 5-14v-11c0-10 5-12 9-12a8 8 0 100-16c-12 0-25 9-25 28v11c0 5-1 5-4 6l-3 1a8 8 0 000 14l3 1c3 2 4 2 4 6v11c0 19 13 28 25 28a8 8 0 100-15zM168 203l-3-1c-4-1-4-2-4-6v-11c0-19-13-28-25-28a8 8 0 100 16c4 0 9 2 9 12v11c0 7 2 11 4 14-2 3-4 7-4 14v11c0 10-5 12-9 12a8 8 0 100 16c12 0 25-9 25-28v-11c0-4 0-5 4-6l3-1a8 8 0 000-14zM268 359H79a8 8 0 110-15h189a8 8 0 110 15zM267 416H78a8 8 0 110-16h189a8 8 0 110 16z"
                            fill="#746e6e"
                          />
                        </svg>
                      </div>
                    </a>
                  </Nav>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

// <div
//   role="navigation"
//   className="items-center justify-center hidden p-4 px-8 text-center md:flex md:visible"
// >
//   {links.map(({ name, location }, index) => (
//     <div
//       key={name}
//       className="flex-1"
//       style={{ order: index <= 1 ? index : index + 1 }}
//     >
//       <Nav href={location} activeClassName="active font-extrabold">
//         <a className="text-xl">{name}</a>
//       </Nav>
//     </div>
//   ))}
//   <div className="flex-1 order-2">
//     <Nav href="/">
//       <a rel="home" title="to homepage" className="no-underline">
//         <div className="hidden dark:block">
//           <svg
//             className="w-12 h-12"
//             viewBox="0 0 512 512"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               clipRule="evenodd"
//               d="M7.56 121.97l243.04 33.55 253.84-33.55V76.76c0-27.9-22.87-50.71-50.78-50.71H58.3c-27.91 0-50.75 22.82-50.75 50.7z"
//               fill="#eee1dc"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M504.44 435.21V121.97H7.56v313.25c0 27.91 22.84 50.73 50.75 50.73h395.35c27.91 0 50.78-22.82 50.78-50.73z"
//               fill="#60b7ff"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M448.7 377c4.28 0 7.8-3.5 7.8-7.78v-20.67a7.82 7.82 0 00-7.8-7.78h-7.48a64.65 64.65 0 00-5.47-13.34l5.24-5.24a7.77 7.77 0 000-10.98l-14.62-14.64a7.82 7.82 0 00-11.03 0l-5.24 5.24a64.14 64.14 0 00-13.35-5.47v-7.47a7.78 7.78 0 00-7.8-7.76h-20.68a7.8 7.8 0 00-7.8 7.76v7.81a63.92 63.92 0 00-12.95 5.53l-5.64-5.64a7.79 7.79 0 00-11 0l-14.64 14.64a7.77 7.77 0 000 10.98l5.98 5.98a62.72 62.72 0 00-5.1 12.6h-8.6a7.8 7.8 0 00-7.76 7.78v20.67a7.8 7.8 0 007.77 7.79h8.93a65.6 65.6 0 005.13 12.23l-6.35 6.34a7.8 7.8 0 000 11.01l14.65 14.61a7.79 7.79 0 0011 0l6.34-6.34a62.16 62.16 0 0012.25 5.12v8.92a7.82 7.82 0 007.79 7.79h20.69a7.8 7.8 0 007.8-7.79v-8.58a65.51 65.51 0 0012.63-5.07l5.95 5.95a7.82 7.82 0 0011.03 0l14.62-14.6a7.8 7.8 0 000-11.02l-5.64-5.63a62.38 62.38 0 005.53-12.94zm-70.09-50.05a31.95 31.95 0 110 63.87c-17.65 0-31.97-14.3-31.97-31.93s14.32-31.94 31.97-31.94z"
//               fill="#9d9696"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M378.61 390.82c17.66 0 31.97-14.3 31.97-31.93s-14.31-31.94-31.97-31.94-31.97 14.3-31.97 31.94 14.32 31.93 31.97 31.93z"
//               fill="#eee1dc"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M296.26 89.36a16.02 16.02 0 100-32.05 16.02 16.02 0 100 32.05z"
//               fill="#fd4755"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M364.44 89.36a16.02 16.02 0 100-32.05 16.02 16.02 0 100 32.05z"
//               fill="#fdb440"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M432.63 89.36a16.04 16.04 0 100-32.05c-8.87 0-16.07 7.16-16.07 16.02s7.2 16.03 16.07 16.03z"
//               fill="#80d261"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M504.44 121.97V76.76c0-27.9-22.87-50.71-50.78-50.71H425.7c27.92 0 50.76 22.82 50.76 50.7v45.22h27.97z"
//               fill="#cdbeb9"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M504.44 435.21V121.97h-27.97v313.25c0 27.91-22.84 50.73-50.76 50.73h27.95c27.91 0 50.78-22.82 50.78-50.73z"
//               fill="#22a6fe"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M359.8 296.88c7.28 8.04 13.37 18.3 17.85 30.1.31-.03.65-.03.96-.03a31.95 31.95 0 016.5 63.22c-1.93 17.55-7.06 33.52-14.49 46.52h18.34a7.8 7.8 0 007.8-7.79v-8.58a65.51 65.51 0 0012.63-5.06l5.95 5.94a7.82 7.82 0 0011.03 0l14.62-14.6a7.8 7.8 0 000-11.02l-5.64-5.63a62.38 62.38 0 005.53-12.94h7.82c4.28 0 7.8-3.51 7.8-7.79v-20.67a7.82 7.82 0 00-7.8-7.78h-7.48a64.65 64.65 0 00-5.47-13.34l5.24-5.24a7.77 7.77 0 000-10.98l-14.62-14.64a7.82 7.82 0 00-11.03 0l-5.24 5.24a64.14 64.14 0 00-13.35-5.46v-7.48a7.78 7.78 0 00-7.8-7.75h-20.68a7.8 7.8 0 00-7.8 7.75v7.82c-.22.05-.45.14-.67.2z"
//               fill="#746e6e"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M377.65 326.98c5.3 13.98 8.33 30.12 8.33 47.36 0 5.38-.31 10.68-.88 15.83a31.95 31.95 0 00-6.49-63.22z"
//               fill="#cdbeb9"
//               fillRule="evenodd"
//             />
//             <path d="M210.67 191.01h232.02a7.55 7.55 0 100-15.1H210.67a7.55 7.55 0 100 15.1zM210.67 246.03h232.02a7.55 7.55 0 100-15.1H210.67a7.55 7.55 0 100 15.1zM272.65 285.96h-89.61a7.55 7.55 0 100 15.1h89.61a7.55 7.55 0 100-15.1zM78 293.51a7.55 7.55 0 007.55 7.55h57.53a7.55 7.55 0 100-15.1H85.55a7.55 7.55 0 00-7.56 7.55zM99.86 263.92a7.55 7.55 0 100-15.1c-4.22 0-9.25-2.13-9.25-12.24v-10.65c0-6.22-1.82-10.44-4.22-13.35 2.4-2.91 4.22-7.13 4.22-13.35V188.6c0-10.12 5.03-12.24 9.25-12.24a7.55 7.55 0 100-15.1c-12.13 0-24.36 8.45-24.36 27.34v10.64c0 3.97-.72 4.23-4.2 5.53-.79.3-1.6.6-2.44.98a7.55 7.55 0 00-.56 13.4c.16.11 2.25 1 3 1.28 3.48 1.28 4.2 1.54 4.2 5.51v10.64c0 18.9 12.23 27.35 24.36 27.35zM148.42 235.39c0 10.12-5.03 12.24-9.25 12.24a7.55 7.55 0 100 15.1c12.13 0 24.36-8.45 24.36-27.34v-10.62c0-3.96.72-4.23 4.2-5.52.75-.28 1.53-.58 2.33-.94l.43-.22a7.55 7.55 0 00-.36-13.55 34.2 34.2 0 00-2.4-.96c-3.48-1.27-4.2-1.54-4.2-5.5v-10.65c0-18.89-12.23-27.34-24.36-27.34a7.55 7.55 0 100 15.1c4.22 0 9.25 2.12 9.25 12.24v10.65c0 6.22 1.82 10.43 4.22 13.35-2.4 2.91-4.22 7.13-4.22 13.35v10.6zM267.66 340.97H84.56a7.55 7.55 0 100 15.1h183.1a7.55 7.55 0 100-15.1zM266.67 396.01H83.57a7.55 7.55 0 100 15.1h183.1a7.55 7.55 0 100-15.1zM432.63 96.9c13.01 0 23.6-10.57 23.6-23.57a23.61 23.61 0 00-47.23 0c0 13 10.6 23.57 23.63 23.57zm0-32.04c4.68 0 8.48 3.8 8.48 8.47a8.5 8.5 0 01-17 0 8.5 8.5 0 018.52-8.47zM364.44 96.9c13.02 0 23.6-10.57 23.6-23.57s-10.58-23.57-23.6-23.57c-13 0-23.6 10.57-23.6 23.57s10.6 23.57 23.6 23.57zm0-32.04c4.68 0 8.49 3.8 8.49 8.47a8.5 8.5 0 01-16.97 0c0-4.67 3.8-8.47 8.48-8.47zM296.26 96.9c13.01 0 23.6-10.57 23.6-23.57s-10.59-23.57-23.6-23.57c-13.02 0-23.6 10.57-23.6 23.57s10.58 23.57 23.6 23.57zm0-32.04c4.68 0 8.48 3.8 8.48 8.47a8.5 8.5 0 01-16.97 0c0-4.67 3.81-8.47 8.49-8.47z" />
//             <path d="M453.66 18.5H58.3C26.16 18.5 0 44.63 0 76.76v358.46a58.37 58.37 0 0058.31 58.28h395.35c32.17 0 58.34-26.15 58.34-58.28V76.76c0-32.13-26.17-58.26-58.34-58.26zm0 459.9H58.3a43.24 43.24 0 01-43.2-43.18v-305.7h111.05a7.55 7.55 0 100-15.1H15.12V76.76a43.23 43.23 0 0143.2-43.16h395.34a43.24 43.24 0 0143.23 43.16v37.66H160.76a7.55 7.55 0 100 15.1H496.9v305.7a43.26 43.26 0 01-43.23 43.18z" />
//             <path d="M448.7 333.22h-2.02a72.32 72.32 0 00-1.75-4.28l1.4-1.4c2.9-2.9 4.5-6.77 4.5-10.89a15.13 15.13 0 00-4.49-10.77l-14.63-14.65a15.26 15.26 0 00-10.86-4.48c-4.1 0-7.96 1.6-10.85 4.48l-1.4 1.4a71.6 71.6 0 00-4.3-1.75v-2.01c0-8.44-6.88-15.3-15.34-15.3h-20.69a15.35 15.35 0 00-15.35 15.3v2.44a70.79 70.79 0 00-3.94 1.68l-1.75-1.76a15.25 15.25 0 00-10.85-4.48h-.04c-4.1 0-7.93 1.6-10.8 4.49l-14.62 14.6c-2.9 2.87-4.5 6.71-4.51 10.81a15.22 15.22 0 004.48 10.88l2.18 2.18c-.5 1.16-.98 2.33-1.42 3.5h-3.12a15.35 15.35 0 00-15.32 15.34v20.67c0 8.45 6.87 15.33 15.32 15.33h3.56a73.2 73.2 0 001.32 3.17l-2.52 2.52a15.35 15.35 0 00.01 21.7l14.62 14.57c2.87 2.9 6.72 4.5 10.82 4.51h.04c4.1 0 7.95-1.59 10.85-4.48l2.5-2.5c1.06.46 2.12.9 3.2 1.32v3.54c0 8.45 6.88 15.33 15.34 15.33h20.69c8.46 0 15.35-6.88 15.35-15.33v-3.12a73 73 0 003.52-1.41l2.17 2.17c2.9 2.89 6.75 4.48 10.86 4.48s7.96-1.6 10.85-4.48l14.63-14.61c2.89-2.9 4.48-6.75 4.48-10.85s-1.59-7.95-4.48-10.84l-1.75-1.75c.6-1.3 1.16-2.61 1.67-3.94h2.44c8.46 0 15.35-6.88 15.35-15.33v-20.67c0-8.45-6.89-15.33-15.35-15.33zm.23 36c0 .1-.13.24-.23.24h-7.82a7.56 7.56 0 00-7.25 5.39 55.09 55.09 0 01-4.86 11.37 7.54 7.54 0 001.24 9.06l5.64 5.64c.08.08.08.25 0 .33l-14.63 14.61c-.03.03-.3.04-.34 0l-5.95-5.94a7.56 7.56 0 00-8.85-1.35 58.12 58.12 0 01-11.18 4.49 7.55 7.55 0 00-5.5 7.26v8.58c0 .1-.11.24-.24.24h-20.7c-.1 0-.23-.13-.23-.24v-8.92c0-3.34-2.2-6.28-5.4-7.23a54.64 54.64 0 01-10.75-4.5 7.54 7.54 0 00-9 1.27l-6.34 6.34c-.02.02-.06.06-.16.06-.09 0-.11-.02-.15-.06l-14.65-14.6c-.08-.09-.08-.26 0-.34l6.35-6.34c2.37-2.37 2.9-6.01 1.3-8.95a58 58 0 01-4.54-10.82 7.56 7.56 0 00-7.23-5.35h-8.93c-.1 0-.21-.12-.21-.24v-20.67c0-.12.12-.23.2-.23h8.6a7.56 7.56 0 007.27-5.5 55.4 55.4 0 014.49-11.09 7.54 7.54 0 00-1.32-8.9l-5.98-5.97c-.02-.02-.06-.06-.06-.17 0-.08.03-.1.06-.14l14.65-14.64.03-.02c0-.01.03-.04.11-.04.1 0 .15.04.17.06l5.64 5.63c2.4 2.4 6.1 2.9 9.05 1.25 3.66-2.06 7.5-3.7 11.42-4.87a7.55 7.55 0 005.38-7.24v-7.8c0-.1.12-.22.24-.22h20.69c.13 0 .23.11.23.21v7.48a7.55 7.55 0 005.5 7.26 56.91 56.91 0 0111.78 4.82 7.56 7.56 0 008.97-1.28l5.25-5.24c.03-.03.3-.03.33 0l14.65 14.66c0 .01.04.04.04.12 0 .1-.05.15-.07.17l-5.24 5.24a7.54 7.54 0 00-1.28 8.96 57.2 57.2 0 014.83 11.78 7.56 7.56 0 007.26 5.48h7.49c.1 0 .23.13.23.23v20.67z" />
//             <path d="M378.61 319.4c-21.8 0-39.52 17.71-39.52 39.49s17.73 39.48 39.52 39.48c21.8 0 39.53-17.71 39.53-39.48S400.4 319.4 378.6 319.4zm0 63.87c-13.46 0-24.4-10.94-24.4-24.38s10.94-24.39 24.4-24.39c13.46 0 24.41 10.94 24.41 24.39s-10.95 24.38-24.4 24.38z" />
//           </svg>
//         </div>
//         <div className="block dark:hidden">
//           <svg
//             className="w-12 h-12"
//             viewBox="0 0 512 512"
//             height="50"
//             width="50"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               clipRule="evenodd"
//               d="M0 118l250 34 262-34V71c0-29-24-52-52-52H52C24 19 0 42 0 71z"
//               fill="#eee1dc"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M512 441V118H0v323c0 29 24 52 52 52h408c28 0 52-23 52-52z"
//               fill="#60b7ff"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M455 381c4 0 8-4 8-8v-22c0-4-4-8-8-8h-8c-2-4-3-9-6-13l6-6c3-3 3-8 0-11l-15-15c-4-3-9-3-12 0l-5 5-14-5v-8c0-5-4-8-8-8h-21c-5 0-8 3-8 8v8c-5 1-9 3-14 6l-6-6c-3-3-8-3-11 0l-15 15c-3 3-3 8 0 11l6 6-5 13h-9c-4 0-8 4-8 8v22c0 4 4 8 8 8h9l6 12-7 7c-3 3-3 8 0 11l15 15c3 4 8 4 11 0l7-6 13 5v9c0 5 3 8 8 8h21c4 0 8-3 8-8v-9l13-5 6 6c3 4 8 4 12 0l15-15c3-3 3-8 0-11l-6-6 6-13h8zm-73-52a33 33 0 110 66 33 33 0 010-66z"
//               fill="#9d9696"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M382 395a33 33 0 100-66 33 33 0 000 66z"
//               fill="#eee1dc"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M297 84a17 17 0 101-33 17 17 0 00-1 33z"
//               fill="#fd4755"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M368 84a17 17 0 100-33 17 17 0 000 33z"
//               fill="#fdb440"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M438 84a17 17 0 100-33 17 17 0 000 33z"
//               fill="#80d261"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M512 118V71c0-29-24-52-52-52h-29c29 0 52 23 52 52v47z"
//               fill="#cdbeb9"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M512 441V118h-29v323c0 29-23 52-52 52h29c28 0 52-23 52-52z"
//               fill="#22a6fe"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M363 298c7 8 14 19 18 31h1a33 33 0 017 65c-2 18-7 35-15 48h19c4 0 8-3 8-8v-9l13-5 6 6c3 4 8 4 12 0l15-15c3-3 3-8 0-11l-6-6 5-13h9c4 0 8-4 8-8v-22c0-4-4-8-8-8h-8c-2-4-3-9-6-13l6-6c3-3 3-8 0-11l-15-15c-4-3-9-3-12 0l-5 5-14-5v-8c0-5-4-8-8-8h-21c-5 0-8 3-8 8v8h-1z"
//               fill="#746e6e"
//               fillRule="evenodd"
//             />
//             <path
//               clipRule="evenodd"
//               d="M381 329a139 139 0 018 65 33 33 0 00-7-65z"
//               fill="#cdbeb9"
//               fillRule="evenodd"
//             />
//             <path
//               d="M448 189H209a8 8 0 110-16h239a8 8 0 110 16zM448 246H209a8 8 0 110-16h239a8 8 0 110 16zM273 302h-92a8 8 0 110-15h92a8 8 0 110 15zM140 302H80a8 8 0 110-15h60a8 8 0 110 15zM95 249c-4 0-9-3-9-13v-11c0-6-2-11-5-14 3-3 5-7 5-14v-11c0-10 5-12 9-12a8 8 0 100-16c-12 0-25 9-25 28v11c0 5-1 5-4 6l-3 1a8 8 0 000 14l3 1c3 2 4 2 4 6v11c0 19 13 28 25 28a8 8 0 100-15zM168 203l-3-1c-4-1-4-2-4-6v-11c0-19-13-28-25-28a8 8 0 100 16c4 0 9 2 9 12v11c0 7 2 11 4 14-2 3-4 7-4 14v11c0 10-5 12-9 12a8 8 0 100 16c12 0 25-9 25-28v-11c0-4 0-5 4-6l3-1a8 8 0 000-14zM268 359H79a8 8 0 110-15h189a8 8 0 110 15zM267 416H78a8 8 0 110-16h189a8 8 0 110 16z"
//               fill="#746e6e"
//             />
//           </svg>
//         </div>
//       </a>
//     </Nav>
//   </div>
// </div>;
